import { ReloadThePage } from '../icon/library/ReloadThePage';
import { AddImage } from './library/AddImage';
import { AddPhoto } from './library/AddPhoto';
import { Alert } from './library/Alert';
import { Cut } from './library/Cut';
import { Delete } from './library/Delete';
import { Empty } from './library/Empty';
import { Error } from './library/Error';
import { Exit } from './library/Exit';
import { Exit2 } from './library/Exit2';
import { FamilyAndFriends } from './library/FamilyAndFriends';
import { Import } from './library/Import';
import { ImportFailed } from './library/ImportFailed';
import { ImportSuccess } from './library/ImportSuccess';
import { InfoZoom } from './library/InfoZoom';
import { LowQualitySpecialImage } from './library/LowQualitySpecialImage';
import { NoWifi } from './library/NoWifi';
import { OpsErrorCode } from './library/OpsErrorCode';
import { Photo } from './library/Photo';
import { PhotoAlbum } from './library/PhotoAlbum';
import { PicAI } from './library/PicAI';
import { Placeholder } from './library/Placeholder';
import { PointingHand } from './library/PointingHand';
import { Projects } from './library/Projects';
import { Promo } from './library/Promo';
import { ShareFamily } from './library/ShareFamily';
import { SpinnerSvg } from './library/Spinner';
import { Upload } from './library/Upload';
import { UploadFailed } from './library/UploadFailed';
import { ZoomIn } from './library/ZoomIn';

export type IllustrationName = keyof typeof illustrationLibrary;

export enum ILLUSTRATION_NAMES {
  Placeholder = 'placeholder',
  Exit = 'exit',
  Delete = 'delete',
  Import = 'import',
  ShareFamily = 'share-family',
  Projects = 'projects',
  OpsErrorCode = 'ops-error-code',
  Empty = 'empty',
  Exit2 = 'exit-2',
  PhotoAlbum = 'photo-album',
  PicAI = 'pic-ai',
  Promo = 'promo',
  Cut = 'cut',
  Spinner = 'spinner',
  ZoomIn = 'zoom-in',
  PointingHand = 'pointing-hand',
  Upload = 'upload',
  InfoZoom = 'info-zoom',
  AddImage = 'add-image',
  UploadFailed = 'upload-failed',
  Error = 'error',
  ImportFailed = 'import-failed',
  AddPhoto = 'add-photo',
  FamilyAndFriends = 'family-and-friends',
  Photo = 'photo',
  NoWifi = 'no-wifi',
  ReloadThePage = 'ReloadThePage',
  ImportSuccess = 'import-success',
  LowQualitySpecialImage = 'low-quality-special-image',
  Alert = 'alert',
}

export const illustrationLibrary = {
  [ILLUSTRATION_NAMES.Placeholder]: Placeholder,
  [ILLUSTRATION_NAMES.Exit]: Exit,
  [ILLUSTRATION_NAMES.Delete]: Delete,
  [ILLUSTRATION_NAMES.Import]: Import,
  [ILLUSTRATION_NAMES.ShareFamily]: ShareFamily,
  [ILLUSTRATION_NAMES.Projects]: Projects,
  [ILLUSTRATION_NAMES.OpsErrorCode]: OpsErrorCode,
  [ILLUSTRATION_NAMES.Empty]: Empty,
  [ILLUSTRATION_NAMES.PhotoAlbum]: PhotoAlbum,
  [ILLUSTRATION_NAMES.PicAI]: PicAI,
  [ILLUSTRATION_NAMES.Exit2]: Exit2,
  [ILLUSTRATION_NAMES.Promo]: Promo,
  [ILLUSTRATION_NAMES.Cut]: Cut,
  [ILLUSTRATION_NAMES.Spinner]: SpinnerSvg,
  [ILLUSTRATION_NAMES.ZoomIn]: ZoomIn,
  [ILLUSTRATION_NAMES.PointingHand]: PointingHand,
  [ILLUSTRATION_NAMES.Upload]: Upload,
  [ILLUSTRATION_NAMES.InfoZoom]: InfoZoom,
  [ILLUSTRATION_NAMES.AddImage]: AddImage,
  [ILLUSTRATION_NAMES.UploadFailed]: UploadFailed,
  [ILLUSTRATION_NAMES.Error]: Error,
  [ILLUSTRATION_NAMES.ImportFailed]: ImportFailed,
  [ILLUSTRATION_NAMES.AddPhoto]: AddPhoto,
  [ILLUSTRATION_NAMES.FamilyAndFriends]: FamilyAndFriends,
  [ILLUSTRATION_NAMES.Photo]: Photo,
  [ILLUSTRATION_NAMES.NoWifi]: NoWifi,
  [ILLUSTRATION_NAMES.ReloadThePage]: ReloadThePage,
  [ILLUSTRATION_NAMES.ImportSuccess]: ImportSuccess,
  [ILLUSTRATION_NAMES.LowQualitySpecialImage]: LowQualitySpecialImage,
  [ILLUSTRATION_NAMES.Alert]: Alert,
};
